export const SpotifyPlaylistLink = ({
  title,
  mediaId,
}: {
  title: string;
  mediaId: string;
}) => (
  <iframe
    title={title}
    src={`https://open.spotify.com/embed/playlist/${mediaId}`}
    width="100%"
    height="380"
    frameBorder="0"
    allowFullScreen
    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
  />
);
